"use client";
import React from "react";

export const DoughnutChart = ({ data, size = 200 }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  const radius = size / 2;
  const strokeWidth = size / 8;
  const innerRadius = radius - strokeWidth;
  const center = size / 2;

  let currentAngle = 0;

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm">
      <h3 className="text-gray-700 font-medium mb-4">Distribution</h3>
      <div className="flex items-center gap-8">
        <svg width={size} height={size} className="transform -rotate-90">
          {data.map((item, index) => {
            const percentage = (item.value / total) * 100;
            const angle = (percentage / 100) * 360;
            const largeArcFlag = angle > 180 ? 1 : 0;

            // Calculate path coordinates
            const startX =
              center + innerRadius * Math.cos((currentAngle * Math.PI) / 180);
            const startY =
              center + innerRadius * Math.sin((currentAngle * Math.PI) / 180);
            const endX =
              center +
              innerRadius * Math.cos(((currentAngle + angle) * Math.PI) / 180);
            const endY =
              center +
              innerRadius * Math.sin(((currentAngle + angle) * Math.PI) / 180);

            const path = `
              M ${center} ${center}
              L ${startX} ${startY}
              A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}
              L ${center} ${center}
            `;

            const segment = (
              <path
                key={index}
                d={path}
                fill={item.color}
                className="transition-all duration-300 hover:opacity-80"
              />
            );

            currentAngle += angle;
            return segment;
          })}
          {/* Inner circle */}
          <circle
            cx={center}
            cy={center}
            r={innerRadius - strokeWidth}
            fill="white"
          />
        </svg>
        <div className="flex flex-col gap-2">
          {data.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-sm text-gray-600">{item.label}</span>
              <span className="text-sm font-medium text-gray-700">
                {((item.value / total) * 100).toFixed(1)}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
